export default "__VITE_ASSET__D1tAaT16__"